/**
 * Armen voor de experimenten die de Mixed Offer Engine uitvoert (MKT-1704, SHO-10800).
 *
 * De engine laat een campagne met een experimentId alleen zien aan de arm die het thema
 * meestuurt, en verbergt hem als er geen arm meekomt (fail closed). Deze module zet de arm
 * daarom op elke pagina, vóór mixed-offer.js en free-gifts.js hun eerste aanvraag doen:
 * `window.__HDS_EXPERIMENT_ARMS__ = { lijmkeuze: 'control' | 'treatment' }`.
 *
 * Een arm zetten telt de bezoeker nog niet mee; dat doet mixed-offer.js met expose() zodra
 * een cadeau van zo'n campagne in de mand ligt. Aan/uit staat in de engine (experimentId
 * leegmaken), niet hier: een arm voor een experiment zonder campagne doet niets.
 */

import { setTreatmentShare, variantOf } from '@theme/hds-experiments';

/** Experimenten die de engine kent. `lijmkeuze`: gratis lijm óf een kortingscode (DB-026). */
const ENGINE_EXPERIMENTS = ['lijmkeuze'];

/**
 * Aandeel treatment in procent, alleen voor experimenten die niet 50/50 lopen. Lijmkeuze: 40%
 * krijgt gratis lijm via de code (gestart op 20% om het margerisico klein te houden, opgehoogd in
 * SHO-10801 voor meer treatment-data).
 * Ophogen houdt elke treatment-bezoeker in treatment (`% 100 < aandeel`); alleen een deel van
 * control wisselt, en de dagkaart telt daarna alleen nieuwe blootstellingen (register: ga4.vanaf).
 * Verlagen of precies 50 kiezen herverdeelt wél: bij 50 schakelt variantFrom() over op `% 2`.
 */
const TREATMENT_SHARE = { lijmkeuze: 40 };

try {
  const arms = /** @type {any} */ (window).__HDS_EXPERIMENT_ARMS__ || {};
  for (const id of ENGINE_EXPERIMENTS) {
    if (TREATMENT_SHARE[id]) setTreatmentShare(id, TREATMENT_SHARE[id]);
    if (!arms[id]) arms[id] = variantOf(id);
  }
  /** @type {any} */ (window).__HDS_EXPERIMENT_ARMS__ = arms;
} catch {
  // Zonder armen verbergt de engine de experiment-campagnes; winkelen gaat gewoon door.
} finally {
  /** @type {any} */ (window).__HDS_EXPERIMENT_ARMS_READY__ = true;
  document.dispatchEvent(new CustomEvent('hds:experiment-arms'));
}
